export default __webpack_public_path__ + "static/media/PhosphorusBanner.a67b17c7.png";